import CleverTap from 'clevertap-web-sdk/clevertap';

export async function initializeClevertap(): Promise<CleverTap> {
  const clevertapModule = await import('clevertap-web-sdk');

  clevertapModule.default.init(process.env.CLEVERTAP_ACCOUNT_ID || '', 'in1');
  clevertapModule.default.privacy.push({ optOut: false });
  clevertapModule.default.privacy.push({ useIP: true });
  clevertapModule.default.spa = true;
  clevertapModule.default.setLogLevel(3);

  return clevertapModule.default;
}
